import { createI18n } from 'vue-i18n'
import en from './langs/en.json'
import es from './langs/es.json'

const i18n = createI18n({
    legacy: false,
    locale: 'es',
    fallbackLocale: 'en',
    messages: {
        en: en,
        es: es,
    }
})

export default i18n;
